import { Model } from '@/clients/http'

import { OrderSourceHttpParams, OrderSourceResponses } from '@/types'

export class OrderSourceModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_ORDER_SOURCE_LIST',
    GET_BY_ID: 'GET_ORDER_SOURCE_BY_ID',
    CREATE: 'CREATE_ORDER_SOURCE',
    UPDATE: 'UPDATE_ORDER_SOURCE',
    DELETE: 'DELETE_ORDER_SOURCE',
  }

  public static readonly endpoints = {
    getList: (props?: OrderSourceHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/order-source',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: OrderSourceHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/order-source/:id',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: OrderSourceHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/order-source',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: OrderSourceHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/order-source/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: OrderSourceHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/order-source/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (props?: OrderSourceHttpParams.GetList) => {
    return this.createHttpRequest<OrderSourceResponses.GetList, OrderSourceResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly create = async (props: OrderSourceHttpParams.Create) => {
    return this.createHttpRequest<OrderSourceResponses.Create, OrderSourceResponses.CreateError>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly update = async (props: OrderSourceHttpParams.Update) => {
    return this.createHttpRequest<OrderSourceResponses.Update, OrderSourceResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly delete = async (props: OrderSourceHttpParams.Delete) => {
    return this.createHttpRequest<OrderSourceResponses.Delete, OrderSourceResponses.DeleteError>({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
